import { useTranslation } from "react-i18next"
import { TRIP_PRICE } from "../../../utils/constants"
import { AllowedTypesFormItem } from "../AllowedTypesFormItem"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import PropTypes from "prop-types"

export const AllowedTypesBlock = ({ setChildrenAllowed, setInfantsAllowed, setPassengersAllowed }) => {
  const [t] = useTranslation()
  return (
    <Flex vertical>
      <Text variant="sub" size="md" className="mb-m">
        {t("experiences.scheduling.sections.length_and_rates.allowed_guests_block_title")}
      </Text>
      <AllowedTypesFormItem
        text={t("experiences.scheduling.sections.length_and_rates.adults")}
        subText={t("experiences.scheduling.sections.length_and_rates.available_by_default")}
        hiddenSwitch
      />
      <AllowedTypesFormItem
        name={TRIP_PRICE.CHILDREN_ALLOWED}
        text={t("experiences.scheduling.sections.length_and_rates.children")}
        subText={t("experiences.scheduling.sections.length_and_rates.under_12_years")}
        handleSwitchChange={setChildrenAllowed}
      />
      <AllowedTypesFormItem
        name={TRIP_PRICE.INFANTS_ALLOWED}
        text={t("experiences.scheduling.sections.length_and_rates.infants")}
        subText={t("experiences.scheduling.sections.length_and_rates.under_2_years")}
        handleSwitchChange={setInfantsAllowed}
      />
      <AllowedTypesFormItem
        name={TRIP_PRICE.PASSENGERS_ALLOWED}
        text={t("experiences.scheduling.sections.length_and_rates.passengers")}
        infoText={t("experiences.scheduling.sections.length_and_rates.passengers_info")}
        handleSwitchChange={setPassengersAllowed}
      />
    </Flex>
  )
}
AllowedTypesBlock.propTypes = {
  setChildrenAllowed: PropTypes.func.isRequired,
  setInfantsAllowed: PropTypes.func.isRequired,
  setPassengersAllowed: PropTypes.func.isRequired,
};
